/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Research_DescriptionInputs */

const en_directory_taxonomy_use_cases_research_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Research_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search products for analysis, discovery, and structured knowledge work.`)
};

const zh_directory_taxonomy_use_cases_research_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Research_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索适用于分析、发现和结构化知识工作的产品。`)
};

/**
* | output |
* | --- |
* | "Search products for analysis, discovery, and structured knowledge work." |
*
* @param {Directory_Taxonomy_Use_Cases_Research_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_research_description = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Research_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Research_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_research_description(inputs)
	return zh_directory_taxonomy_use_cases_research_description(inputs)
});
export { directory_taxonomy_use_cases_research_description as "directory.taxonomy.use-cases.research.description" }